import {SearchFilterModel} from "../services/filterer/search-filter.model";
import {OrderByModel} from "../services/filterer/orderBy.model";

export interface GetPayloadInterface {
  dtoType:string,
  filters:any[]
  groupByAttributes:string[];
  orderByFilters:OrderByModel[];
}
export class GETRequestPayload implements GetPayloadInterface{
  groupByAttributes: string[];
  orderByFilters: OrderByModel[];
  dtoType:string;
  filters:any[];
  constructor(dtoType:string) {
    this.dtoType = dtoType;
    this.filters = [];
    this.groupByAttributes = [];
    this.orderByFilters = [];
  }

}
